var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRelogio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.802 17.0817L16.856 16.0277L13.079 12.2507V7.55469H11.579V12.8584L15.802 17.0817ZM12.3307 22.0547C11.0167 22.0547 9.78165 21.8054 8.62548 21.3067C7.46931 20.808 6.46365 20.1313 5.60848 19.2764C4.75331 18.4216 4.07623 17.4164 3.57723 16.2607C3.0784 15.105 2.82898 13.8703 2.82898 12.5564C2.82898 11.2424 3.07831 10.0074 3.57698 8.85119C4.07565 7.69502 4.7524 6.68935 5.60723 5.83419C6.46206 4.97902 7.46731 4.30194 8.62298 3.80294C9.77865 3.3041 11.0134 3.05469 12.3272 3.05469C13.6412 3.05469 14.8763 3.30402 16.0325 3.80269C17.1886 4.30135 18.1943 4.9781 19.0495 5.83294C19.9046 6.68777 20.5817 7.69302 21.0807 8.84869C21.5796 10.0044 21.829 11.2391 21.829 12.5529C21.829 13.8669 21.5796 15.102 21.081 16.2582C20.5823 17.4144 19.9056 18.42 19.0507 19.2752C18.1959 20.1304 17.1906 20.8074 16.035 21.3064C14.8793 21.8053 13.6446 22.0547 12.3307 22.0547ZM12.329 20.5547C14.5456 20.5547 16.4331 19.7755 17.9915 18.2172C19.5498 16.6589 20.329 14.7714 20.329 12.5547C20.329 10.338 19.5498 8.45052 17.9915 6.89219C16.4331 5.33385 14.5456 4.55469 12.329 4.55469C10.1123 4.55469 8.22481 5.33385 6.66648 6.89219C5.10815 8.45052 4.32898 10.338 4.32898 12.5547C4.32898 14.7714 5.10815 16.6589 6.66648 18.2172C8.22481 19.7755 10.1123 20.5547 12.329 20.5547Z",
    fill: "#1C1B1F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelogio);
export default __webpack_public_path__ + "static/media/Relogio.9322248f312dc291b44cfedbefcf6f82.svg";
export { ForwardRef as ReactComponent };